import { Component, EventEmitter, Input, OnChanges, Output, ChangeDetectionStrategy } from '@angular/core';
import { ImageResponseContent } from '../../models/chat.models';

@Component({
    selector: 'app-chat-image-message',
    templateUrl: './chat-image-message.component.html',
    styleUrl: './chat-image-message.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChatImageMessageComponent implements OnChanges {
    @Input() imageData?: ImageResponseContent;
    @Input() isMobileApp: boolean = false;
    @Output() imagePreviewOpen = new EventEmitter<boolean>();
    @Input() isCCU: boolean = false;

    imageUrl?: string;
    isImagePreviewOpen: boolean = false;
    previewFiles: { name: string; url: string }[] = [];

    ngOnChanges(): void {
        this.imageUrl = this.buildImageDataUrl(this.imageData?.base64Url, this.imageData?.filename);
    }

    onOpenImage(): void {
        if (this.imageUrl) {
            this.previewFiles = [{
                name: this.imageData?.filename || this.getDefaultImageFileName(this.imageUrl),
                url: this.imageUrl
            }];
            this.isImagePreviewOpen = true;
            this.imagePreviewOpen.emit(true);
        }
    }

    closeImagePreview(): void {
        this.isImagePreviewOpen = false;
        this.previewFiles = [];
        this.imagePreviewOpen.emit(false);
    }

    private buildImageDataUrl(base64Url?: string, filename?: string): string | undefined {
        if (!base64Url) {
            return undefined;
        }

        if (base64Url.startsWith('data:')) {
            return base64Url;
        }

        const extension = filename?.split('.').pop()?.toLowerCase();
        const mimeByExtension: Record<string, string> = {
            png: 'image/png',
            jpg: 'image/jpeg',
            jpeg: 'image/jpeg',
            gif: 'image/gif',
            webp: 'image/webp',
            svg: 'image/svg+xml'
        };
        const mimeType = extension ? (mimeByExtension[extension] ?? 'image/png') : 'image/png';
        return `data:${mimeType};base64,${base64Url}`;
    }

    private getDefaultImageFileName(imageUrl: string): string {
        if (imageUrl.startsWith('data:image/')) {
            const mimeType = imageUrl.substring('data:image/'.length).split(';')[0];
            const extension = mimeType || 'png';
            return `image-preview.${extension}`;
        }
        return 'image-preview.png';
    }
}
